import { Sparkles } from "lucide-react";

const items = [
  "GEMINI 3.1 PRO",
  "5TB CLOUD STORAGE",
  "NOTEBOOKLM PREMIUM",
  "FLOW AI VIDEO",
  "DEEP RESEARCH",
  "CODING ASSISTANT",
  "WORKSPACE AI",
  "MASA AKTIF 18 BULAN",
];

const Row = () => (
  <div className="flex items-center gap-8 shrink-0 pr-8">
    {items.map((item) => (
      <span key={item} className="flex items-center gap-8">
        <span className="font-heading font-bold text-white/90 text-sm md:text-base tracking-[0.18em] whitespace-nowrap">{item}</span>
        <Sparkles className="w-4 h-4 text-cyan-300 shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="bg-[#0B1530] py-4 overflow-hidden relative" data-testid="marquee-strip">
    <div className="flex marquee-track w-max">
      <Row />
      <Row />
    </div>
  </div>
);
